import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { PhaseCostsComponent } from './phase-costs/phase-costs.component'

export const analyticsRoutes: Routes = [
    {
        path: 'analytics',
        children: [RouteUtil.Make('phase-costs', PhaseCostsComponent, FeatureType.BidAnalyticsView)],
    },
]
